// Custom NodeView for variable pills
// Gives us full control over DOM structure to fix cursor positioning
import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { getVariableLabelFromKey } from '../../../../../../../../constants/templateVariables';

interface VariablePillNodeViewProps {
  node: {
    attrs: {
      variableKey: string;
    };
  };
  deleteNode: () => void;
}

const VariablePillNodeView: React.FC<VariablePillNodeViewProps> = ({ node, deleteNode }) => {
  const { variableKey } = node.attrs;
  const label = getVariableLabelFromKey(variableKey);

  console.log('🔵 PILL NodeView Rendering:', {
    variableKey,
    label,
    nodeType: node.type?.name
  });

  const handleDelete = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('🗑️ PILL Deleted:', variableKey);
    deleteNode();
  };

  return (
    <NodeViewWrapper
      as="span"
      className="variable-pill"
      contentEditable={false}
      draggable
      data-variable-key={variableKey}
      data-drag-handle
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.1em',
        backgroundColor: 'rgba(59, 130, 246, 0.2)',
        padding: '0.1em 0.4em',
        borderRadius: '0.25em',
        border: '1px solid rgba(59, 130, 246, 0.3)',
        fontFamily: 'monospace',
        fontSize: '0.9em',
        margin: '0 0.1em',
        cursor: 'default',
        userSelect: 'none',
        verticalAlign: 'baseline',
        position: 'relative',
        lineHeight: '1.2',
        height: 'auto',
      }}
    >
      <span style={{ lineHeight: '1.2', display: 'inline-block' }}>{label}</span>
      <button
        onClick={handleDelete}
        onMouseDown={(e) => e.preventDefault()} // Prevent focus loss
        type="button"
        contentEditable={false}
        style={{
          display: 'none',
          border: 0,
          background: 'transparent',
          color: 'rgb(248, 113, 113)',
          cursor: 'pointer',
          fontSize: '1.1em',
          lineHeight: '1',
          padding: 0,
          margin: 0,
          marginLeft: '0.2em',
        }}
        className="pill-delete"
      >
        ×
      </button>
    </NodeViewWrapper>
  );
};

export default VariablePillNodeView;
